import { X } from 'lucide-react';

export const SelectChip = ({ item, onRemove }) => {
  const handleRemove = e => {
    e.stopPropagation();
    onRemove(item);
  };

  return (
    <button
      type="button"
      onClick={handleRemove}
      className="inline-flex items-center gap-1 shrink-0 rounded-full px-[6px] py-[2px] text-[0.75rem] bg-[#f5f5f5] text-[#100C09] whitespace-nowrap hover:bg-[#e8e8e8] active:bg-[#ddd]"
    >
      {item.title}
      <X
        size={10}
        color="#111926"
      />
    </button>
  );
};
